// extracted by mini-css-extract-plugin
var _1 = "Description_divider__bb12f";
var _2 = "Description_root__e9c0b";
var _3 = "Description_usageIcon__6a980";
export { _1 as "divider", _2 as "root", _3 as "usageIcon" }
